// extracted by mini-css-extract-plugin
export default {"tooltip":"SP-z","arrow":"TP-z"};